
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/les-outils",
      function () {
        return require("private-next-pages/les-outils/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/les-outils"])
      });
    }
  